import { HEATMAP_BLUE_COLOR_STOPS } from 'helpers/heatmap';

export const EARNINGS_BINS = [
  { max: 100, background: HEATMAP_BLUE_COLOR_STOPS[20], text: 'dark' },
  { max: 250, background: HEATMAP_BLUE_COLOR_STOPS[30], text: 'dark' },
  { max: 400, background: HEATMAP_BLUE_COLOR_STOPS[50], text: 'dark' },
  { max: 500, background: HEATMAP_BLUE_COLOR_STOPS[55], text: 'dark' },
  { max: 650, background: HEATMAP_BLUE_COLOR_STOPS[60], text: 'dark' },
  { max: 700, background: HEATMAP_BLUE_COLOR_STOPS[65], text: 'dark' },
  { max: 800, background: HEATMAP_BLUE_COLOR_STOPS[75], text: 'light' },
  { max: 900, background: HEATMAP_BLUE_COLOR_STOPS[80], text: 'light' },
  { max: 1000, background: HEATMAP_BLUE_COLOR_STOPS[85], text: 'light' },
  { max: 1100, background: HEATMAP_BLUE_COLOR_STOPS[90], text: 'light' },
  { max: Infinity, background: HEATMAP_BLUE_COLOR_STOPS[100], text: 'light' },
];
